import { getSectionChildren } from './getSectionChildren';
import { pageComponents, PageSections } from './sections';

type PageSectionProps = {
  name: PageSections;
  props: any;
  children?: React.ReactNode;
};

export const getPageSection = ({ name, props, children }: PageSectionProps) => {
  const SectionComponent = pageComponents[name as PageSections];
  if (!SectionComponent) return null;

  return (
    <SectionComponent {...props}>
      {getSectionChildren(name, props, children)}
    </SectionComponent>
  );
};
